<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="选择报名地址"
    class="center-dialog"
    top="0vh"
    width="50%" 
  >
      <div class="address_box">
            <div class="address_flex">
              <div  class="unit" v-for="(item, index) in addresslist" :key="index" >
                <img src="@/assets/img/地址.png"  />
                <div class="address" >
                  {{ item.address }}
                </div>
                <div style="padding-lfet: 20px"> 剩余名额
                （<span style="color: red">{{ item.all_num-item.enroll_num}}</span>）
                </div>
                <div>
                  距离<span style="color: #6c81b7">{{ item.gap }}km</span>
                </div>
                <div style="padding-left: 20px">
                  <el-checkbox @change="select(item, index, 'checked1')" v-model="item.checked1">首选</el-checkbox>
                  <el-checkbox @change="select(item, index, 'checked2')" v-model="item.checked2">备选1</el-checkbox>
                  <el-checkbox @change="select(item, index, 'checked3')" v-model="item.checked3">备选2</el-checkbox>
                </div>
              </div>
            </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="apply">确认报名</el-button>
      </span>

  </el-dialog>
</template>

<script>
import {
  jobShow,
  jobAddressList,
  jobPostEnroll
} from "@/api/personal/job/index";

export default {

  data() {
    return {
      visible: false,
      job_id: "",
      lat: "",
      lng: "",
      addresslist:[],

     
       
    };
  },
 
  mounted() {

},
  
  methods: {
    handleClose() {
      this.$refs["form"].resetFields();
      this.visible = false;

    },


    init(job_id,lat,lng) {
      this.visible = true;
      this.job_id=job_id;
      this.lat=lat;
      this.lng=lng;
      this.getAddressList();
    },

    getAddressList () {
      jobAddressList({
        job_id: this.job_id,
        lat: this.lat,
        lng: this.lng,
      }).then((res) => {
        this.addresslist = res.data;
      });
    },

    apply(){
      var that=this;

      let adlist = [];
      this.addresslist.forEach((item) => {
        if (item.checked1) {
          adlist.push(item.j_address_id);
        }
      });
      this.addresslist.forEach((item) => {
        if (item.checked2) {
          adlist.push(item.j_address_id);
        }
      });
      this.addresslist.forEach((item) => {
        if (item.checked3) {
          adlist.push(item.j_address_id);
        }
      });
      let data = {
        job_id: this.job_id,
        address_ids: adlist,
      };


           
      jobPostEnroll(data).then((res) => {
        if (res.code == 200) {
          this.visible=false;
          this.$message({
            type: "success",
            message: res.msg,
          });
          //this.getInfo();
        } else {
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      });

    },



    select (item, index, val) {
      if (index === 0) {
        if (this.addresslist[1][val] || this.addresslist[2][val]) {
          this.$message({
            type: "warning",
            message: "请勿重复选择",
          });
          item[val] = false;
        } else {
          this.testcks(item, val);
        }
      } else if (index === 1) {
        if (this.addresslist[0][val] || this.addresslist[2][val]) {
          this.$message({
            type: "warning",
            message: "请勿重复选择",
          });
          item[val] = false;
        } else {
          this.testcks(item, val);
        }
      } else {
        if (this.addresslist[0][val] || this.addresslist[1][val]) {
          this.$message({
            type: "warning",
            message: "请勿重复选择",
          });
          item[val] = false;
        } else {
          this.testcks(item, val);
        }
      }
      if (
        !this.addresslist[0].checked1 &&
        !this.addresslist[1].checked1 &&
        !this.addresslist[2].checked1
      ) {
        item[val] = false;
        this.$message({
          type: "warning",
          message: "请先选择首选地址",
        });
      }
    },
    testcks (item, val) {
      if (val === "checked1") {
        if (item.checked2 || item.checked3) {
          this.$message({
            type: "warning",
            message: "请勿重复选择",
          });
          item[val] = false;
        }
      } else if (val === "checked2") {
        if (item.checked1 || item.checked3) {
          this.$message({
            type: "warning",
            message: "请勿重复选择",
          });
          item[val] = false;
        }
      } else {
        if (item.checked1 || item.checked2) {
          this.$message({
            type: "warning",
            message: "请勿重复选择",
          });
          item[val] = false;
        }
      }
    },

    
  },

 
};
</script>

<style lang="scss" scoped>
.address_box{

  .unit{
    display: flex; margin: 10px 0;

    img{
      width: 20px;height: 20px;
    }

    .address{
      width: 200px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

</style>
